import { NUMERIC_FIELD_TYPES, VariableDefinition } from '../variable-schema';

export function parseStoredValue(storedValue: unknown, def: VariableDefinition): string | number {
  if (storedValue === undefined || storedValue === null || storedValue === '') {
    return def.defaultValue;
  }

  if (typeof storedValue === 'object' && 'value' in (storedValue as Record<string, unknown>)) {
    const inner = (storedValue as { value: unknown }).value;
    if (typeof inner === 'number' || typeof inner === 'string') {
      return parseStoredValue(inner, def);
    }
  }

  if (NUMERIC_FIELD_TYPES.has(def.type)) {
    const num = parseFloat(String(storedValue));
    if (!Number.isNaN(num)) return num;
    return def.defaultValue;
  }

  return String(storedValue);
}
